import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPhotoCameraReverse$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPhotoCameraReverse extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '01b8762aa6b92e8bef40d7bc183112a634f6e2b1', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '4b899cd254720966bda7cd5a991ae0181b1b5ecc', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '33f8e2874e10e446d5e25d1a361e6d95cedf730c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15 6h3.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H7l.862-1.725A.5.5 0 0 1 8.31 4h5.381a.5.5 0 0 1 .448.275zM4.5 16.5h13v-9h-3.118a.5.5 0 0 1-.447-.276L13.073 5.5H8.927l-.863 1.724a.5.5 0 0 1-.446.276H4.5zm8.305-2.65a.49.49 0 0 1 .594.082l.18.174a.51.51 0 0 1 .005.71l-.032.033c-.216.158-.42.279-.638.384a4 4 0 0 1-.735.26 4 4 0 0 1-.626.102l-.042.003-.134.007h-.011c-.06.004-.09.006-.123.005q-.048 0-.093-.003l-.081-.005a4 4 0 0 1-.451-.045l-.162-.025a4 4 0 0 1-2.023-1.084l-.538-.533-.613.615a.46.46 0 0 1-.464.105l-.03-.01a.45.45 0 0 1-.275-.414l-.001-2.16a.453.453 0 0 1 .451-.452h2.16a.45.45 0 0 1 .32.768l-.66.66.458.46q.14.146.349.302a2.9 2.9 0 0 0 1.019.488q.48.11.925.057c.11-.012.228-.03.34-.056l.073-.024c.147-.042.267-.084.379-.134l.027-.012q.217-.102.399-.23zm.763-4.55a3.96 3.96 0 0 0-2.002-1.078 3 3 0 0 0-.184-.03 4 4 0 0 0-.455-.046l-.057-.003a2 2 0 0 0-.131-.005h-.001l-.107.006-.008.001-.094.005h-.002a3 3 0 0 0-.156.01 4 4 0 0 0-.553.098l-.116.03a3.9 3.9 0 0 0-1.252.61l-.032.033a.505.505 0 0 0 .004.71l.179.177a.51.51 0 0 0 .638.054q.192-.132.408-.23l.03-.014c.106-.048.226-.09.383-.135l.068-.022a3 3 0 0 1 .337-.056c.132-.015.278-.022.449-.012l.065.001.046.002a2.9 2.9 0 0 1 1.736.858l.457.456-.66.661a.45.45 0 0 0-.094.487.46.46 0 0 0 .414.281h2.16a.45.45 0 0 0 .316-.135.45.45 0 0 0 .134-.318V9.533a.45.45 0 0 0-.28-.41.46.46 0 0 0-.49.096l-.613.614z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-photo-camera-reverse", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-photo-camera-reverse"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-photo-camera-reverse":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPhotoCameraReverse$1);
            }
            break;
    } });
}

const CosmosIconPhotoCameraReverse = CosmosIconPhotoCameraReverse$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPhotoCameraReverse, defineCustomElement };
